import { render, staticRenderFns } from "./settingMenu.vue?vue&type=template&id=33ffd8b0&"
import script from "./settingMenu.vue?vue&type=script&lang=js&"
export * from "./settingMenu.vue?vue&type=script&lang=js&"
import style0 from "./settingMenu.vue?vue&type=style&index=0&id=33ffd8b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports